// extracted by mini-css-extract-plugin
export default {"footer":"Preview_footer__EyPuI"};